<template>
  <div class="page zntjMd">
    <div class="page-header" v-loading='waiting'>
      <div class="div-tabs">
        <span class="tabName">企业</span>
        <div class="page-header-action">
          <el-button @click="goSubscribeManagement" type="dialog-confirm" size="small">管理订阅</el-button>
        </div>
      </div>
      <div class="sort-condition">
        <div class="stItem stImType"><span class="ss">商机类型：</span>
          <div class="stType">
            <span :class="id == item.id?'active1':''" v-for="(item,index) in subscribeInfo" :key="index" @click="sortSubscribeType(item,index)">
              {{item.subscriptionName}}
              <i class="circle" v-if="item.infoNum">{{item.infoNum}}</i>
            </span>
          </div>
        </div>
        <div class="stItem stImTime"><span class="ss">商机时间：</span>
          <div class="stType">
            <span :class="timeType == 0?'active2':''" @click="sortSubscribeTime(0)">全部</span>
            <span :class="timeType == 1?'active2':''" @click="sortSubscribeTime(1)">最近3天</span>
            <span :class="timeType == 2?'active2':''" @click="sortSubscribeTime(2)">最近7天</span>
            <span :class="timeType == 3?'active2':''" @click="sortSubscribeTime(3)">最近15天</span>
            <span :class="timeType == 4?'active2':''" @click="sortSubscribeTime(4)">最近30天</span>
            <!-- <span :class="this.timeType == 5?'active2':''" @click="sortSubscribeTime(5)">最近3个月</span> -->
          </div>
        </div>
      </div>
    </div>
    <div class="main" v-loading='loading'>
      <div id="top" ref="top"></div>
      <div element-loading-text="请耐心等待，小T为您大数据计算中...">

        <company-card-list @isUnlock-Change="isUnlockChange" :companyType="10" :subscriptionType="subscriptionType" class="list-box" :batchActions="batchActions" ref="cardlist" :list="list"
          @handle-page-num="handlePageNum" @handle-page="handlePage">
          <div class="">
            <span class="font-15-md">已为您找到 <span class="blueColor" style="color: #5088FF;">{{_totalElements}}</span> 家符合条件的企业</span>
          </div>
        </company-card-list>
      </div>
      <robot />

      <div id="bottom" ref="bottom"></div>
    </div>
    <landing-page ref="landingPageS"></landing-page>
    <right-float ref="rightFloat" :globalRfType="true"></right-float>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import CompanyCardList from '../components/companyCardList'
import Robot from '../components/robot'
import intelSort from '@/views/wigects/intelSortSubscribe'
import landingPage from '@/components/landingPage'
import RightFloat from '@/components/rightFloatBtn'
import { subscribeManagement, subscribeList, subscribeListBatch, clickMark } from '@/views/clue/api/subscribeApi.js'

export default {
  name: 'subscribeList',
  provide() {
    return {
      unlockSourceType: 10
    }
  },
  components: {
    CompanyCardList,
    Robot,
    intelSort,
    landingPage,
    RightFloat
  },
  data() {
    return {
      // optionsTime: [
      //   { value: null, label: '智能排序' },
      //   { value: 1, label: '发布时间从早到晚' },
      //   { value: 2, label: '发布时间从晚到早' }
      // ],
      sortType: { sortType: 1, sortField: 'amount' },
      sortValue: 'amount-1',
      waiting: false,
      loading: false,
      allTotal: 0,
      list: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        tab: 1,
        tableData: []
      },
      scrollTop: 0,
      // unlockDialogShowBatch:false,
      companyList: [],
      // actionLoading: false,

      id: '',//订阅ID
      timeType: 0,//时间类型
      orderField: { "establishTime": "DESC" },//排序字段
      subscribeInfo: [],//管理列表数据
      isUnlock: false,
      subscriptionType: null,//商机订阅类型

    }
  },
  mounted() {
    this.getSubscribeManagement()
  },
  computed: {
    ...mapState({
      surplus: state => state.user.surplus,
      staffInfo: state => state.user.staffInfo
    }),
    batchActions() {
      return this.surplus < 1 ? [false, true, false] : [true, true, false]
    },
    placeholder() {
      return this.placeholderList[this.activeTab]
    },
    _totalElements() {
      if (this.allTotal < 100) return this.allTotal
      if (this.allTotal < 200000) return `${this.allTotal.toString().split('').reduce((res, v) => res ? res + 0 : v, '')}+`
      return '200000+'
    },
  },
  methods: {
    // 过滤解锁
    isUnlockChange(val) {
      this.isUnlock = val
      this.searchByCondition()
    },
    goSubscribeManagement() {
      this.$router.push('/zxk/junbros/subscribeManagement')
    },
    clickMark(item, idx) {
      this.waiting = true
      clickMark({ id: item.id, num: item.totalList }).then(res => {
        if (res.code == 200) {
          this.waiting = false
          this.getSubscribeManagement(idx)
          // subscribeManagement().then(res => {
          //   const paramsList = []
          //   res.data.forEach((v, index) => {
          //     paramsList.push({
          //       id: v.id,
          //       timeType: 0, //角标数默认用全部减去管理businessNum
          //       pageNum: this.list.pageNum,
          //       pageSize: this.list.pageSize,
          //       orderField: v.subscriptionType == 1 ? { "establishTime": "DESC" } : { "icpLastedTime": "DESC" }
          //     })
          //   })
          //   // TODO  替换成一个接口
          //   // subscribeList(paramsList).then(rs => {
          //   //   if (rs.code == 200) {
          //   //     v.infoNum = (rs.data.total - v.businessNum) > 99 ? '99+' : ((rs.data.total - v.businessNum) > 0 ? (rs.data.total - v.businessNum) : '')
          //   //     v.totalList = rs.data.total
          //   //   }
          //   // })
          //   this.subscribeInfo = res.data
          //   this.searchByCondition()
          // })
        }
      })
    },
    // 订阅管理列表
    getSubscribeManagement(i = 0) {
      this.waiting = true
      subscribeManagement().then(res => {
        if (res.code == 200) {
          this.waiting = false
          const paramsList = []
          res.data.forEach((v, index) => {
            paramsList.push({
              id: v.id,
              timeType: this.timeType,
              pageNum: this.list.pageNum,
              pageSize: this.list.pageSize,
              orderField: v.subscriptionType == 1 ? { "establishTime": "DESC" } : { "icpLastedTime": "DESC" }
            })
            if (index == i) {
              this.id = v.id
              this.orderField = v.subscriptionType == 1 ? { "establishTime": "DESC" } : { "icpLastedTime": "DESC" }
              this.subscriptionType = v.subscriptionType
              this.searchByCondition()
            }
          })
          this.subscribeInfo = res.data
          this.waiting = true
          subscribeListBatch({ list: paramsList }).then(({ code, data }) => {
            this.waiting = false
            if (code == 200) {
              this.subscribeInfo.forEach(v => {
                for (const id in data) {
                  if (Object.hasOwnProperty.call(data, id)) {
                    if (id == v.id) {
                      this.$set(v, 'infoNum', (data[id] - v.businessNum) > 99 ? '99+' : ((data[id] - v.businessNum) > 0 ? (data[id] - v.businessNum) : ''))
                      this.$set(v, 'totalList', data[id])
                    }
                  }
                }
              })
            }
          }).catch(err => {
            this.waiting = false
          })
        }

      }).catch(err => {
        this.waiting = false
      })
    },

    sortSubscribeType(item, index) {
      this.list.pageNum = 1
      this.list.pageSize = 10
      this.id = item.id
      this.orderField = item.subscriptionType == 1 ? { "establishTime": "DESC" } : { "icpLastedTime": "DESC" }
      this.subscriptionType = item.subscriptionType
      this.clickMark(item, index)

    },
    sortSubscribeTime(val) {
      this.list.pageNum = 1
      this.list.pageSize = 10
      this.timeType = val
      this.searchByCondition()
    },

    async searchByCondition() {
      this.loading = true
      try {
        let isUnlockN = this.isUnlock ? 1 : 0
        this.clearAllData()
        const data = {
          pageNum: this.list.pageNum,
          pageSize: this.list.pageSize,
          id: this.id,
          timeType: this.timeType,
          orderField: this.orderField,
          isUnLock: parseInt(isUnlockN)
        }
        const res = await subscribeList(data)
        console.log(res)
        this.loading = false

        if (res.data) {
          const { total = 0, items = [] } = res.data
          this.allTotal = total
          this.list.total = total > 15000 ? 15000 : total
          this.list.tableData = items
        }
      } catch (error) {
        this.loading = false
      }
    },
    handlePage(val) {
      if (this.list.pageNum !== val) {
        this.list.pageNum = val
        this.searchByCondition()
      }
    },
    handlePageNum(val) {
      this.list.pageNum = 1
      this.list.pageSize = val
      this.searchByCondition()
    },
    clearAllData() {
      this.allTotal = 0
      this.list.total = 0
      this.list.tableData = []
    },
    removeHtml(str) {
      if (!str) return
      const reTag = /<(?:.|\s)*?>/g
      return str.replace(reTag, '').replace(/&nbsp;/ig, '')
    },
  }
}
</script>

<style lang="scss" scoped>
.font-15-md {
  font-size: 15px;
  font-weight: 600;
  color: rgba(52, 57, 81, 0.7);
}
.goUPDown {
  position: fixed;
  right: 14px;
  bottom: 70px;
  img {
    cursor: pointer;
    display: block;
    margin: auto;
  }
}
.page {
  margin: 0 auto;
  // width: 1100px;
}

.page-header {
  padding: 0 24px;
  align-items: center;

  background: #ffffff;
  box-shadow: 0px 1px 5px 0px rgba(38, 38, 38, 0.1);
  border-radius: 4px;
  margin-bottom: 16px;
  .page-title {
    // color: #409eff;
    font-size: 16px;
    span {
      font-size: 13px;
    }
  }
  &-action {
    margin-left: auto;
    display: flex;
    align-items: center;
    i {
      cursor: pointer;
      font-size: 18px;
      margin-right: 12px;
      color: #409eff;
    }
  }
}
.detail {
  // padding: 0 120px;
  padding: 0;
}
.detail-title {
  display: flex;
  align-items: center;
  height: 50px;
  padding: 0 24px;
  // width: calc(100% - 240px);
  margin: 0 auto;
  background: #fafafd;
  border-radius: 4px 4px 0px 0px;
  &-action {
    margin-left: auto;
    display: flex;
    align-items: center;

    .change-action {
      margin-left: 24px;
      cursor: pointer;
      color: #5088ff;
      img {
        width: 16px;
        height: 16px;
        margin-right: 8px;
        animation: none;
        -webkit-animation: none;
        -ms-animation: none;
        -moz-animation: none;
        -webkit-animation: none;
        -o-animation: none;
        vertical-align: sub;
      }
      &:hover {
        color: #0072ff;
      }
      &:hover img {
        animation: changeRotate 1s linear infinite;
        -webkit-animation: changeRotate 1s linear infinite;
        -ms-animation: changeRotate 1s linear infinite;
        -moz-animation: changeRotate 1s linear infinite;
        -webkit-animation: changeRotate 1s linear infinite;
        -o-animation: changeRotate 1s linear infinite;
      }
    }
  }
}

.intelBox {
  background-color: white;
  margin-top: 16px;
  margin-bottom: 24px;
  box-shadow: 0px 1px 5px 0px rgba(38, 38, 38, 0.1);
}

@keyframes changeRotate {
  0% {
    transform: rotateZ(0deg);
    -ms-transform: rotateZ(0deg);
    -moz-transform: rotateZ(0deg);
    -webkit-transform: rotateZ(0deg);
    -o-transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
    -ms-transform: rotateZ(360deg);
    -moz-transform: rotateZ(360deg);
    -webkit-transform: rotateZ(360deg);
    -o-transform: rotateZ(360deg);
  }
}
.checkBoxes {
  position: relative;
  // top: 28px;
  width: 30px;
}
.page-header {
  .page-header-action {
    .el-button--dialog-confirm {
      width: 88px;
      height: 32px;
      padding: 0;
    }
  }
}
.detail-title {
  em {
    font-size: 16px;
  }
}
.zntjMd {
  .setCheckBox {
    text-align: center;
    height: 72px;
    background: rgba(187, 190, 202, 0.3);
    line-height: 72px;
    border-bottom: none;
  }
}
.font-16-md {
  font-size: 16px;
  font-weight: 600;
  color: rgba(52, 57, 81, 0.7);
}
::v-deep {
  .detail-title-action {
    .el-button + .el-button {
      margin-left: 24px;
    }
    .el-button {
      span {
        font-size: 14px;
      }
    }
    .change-action {
      font-size: 14px;
      margin-top: -1px;
    }

    .el-button {
      i {
        margin-right: 4px;
        &::before {
          content: "";
          width: 20px;
          height: 20px;
          display: inline-block;
          vertical-align: -5px;
        }
      }
    }
    .icon-shoucang1xiao {
      &::before {
        background-image: url("~@/assets/gbIcon/xx.svg");
      }
    }
    .icon-jiesuo {
      &::before {
        background-image: url("~@/assets/gbIcon/unlocking.svg");
      }
    }
  }
  .btnBlock {
    .filter-unlock {
      color: rgb(80, 136, 255);
      margin-right: 0;
      line-height: 38px;
      .el-radio__input.is-checked + .el-radio__label {
        color: rgb(80, 136, 255);
      }
      .el-radio__input.is-checked .el-radio__inner {
        border-color: rgb(80, 136, 255);
        background: rgb(80, 136, 255);
      }
      .el-radio__inner,
      .el-checkbox__inner {
        border: 1px solid rgb(80, 136, 255);
        width: 14px;
        height: 14px;
      }
      .el-checkbox__inner::after {
        top: 1px;
        left: 4px;
      }
    }
  }
}
.page-header {
  .div-tabs {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    padding-top: 17px;
    padding-bottom: 10px;
    margin-bottom: 20px;
    .tabName {
      height: 48px;
      font-weight: bold;
      color: #333333;
      font-size: 15px;
      padding: 0 16px;
      box-sizing: border-box;
      position: relative;
      &::after {
        content: "";
        display: block;
        width: 62px;
        height: 2px;
        position: absolute;
        background: #5088ff;
        bottom: -12px;
      }
    }
  }
  .page-header-action {
    position: absolute;
    right: 0;
    bottom: 8px;
  }
  .sort-condition {
    padding-bottom: 24px;
    .stItem {
      display: flex;
      font-weight: 400;
      color: #333333;
      font-size: 14px;
      &.stImType {
        margin-bottom: 16px;
        .stType {
          span {
            position: relative;
            background: #f0f2f5;
            border-radius: 4px;
            margin-right: 16px;
            padding: 4px 16px;
            box-sizing: border-box;
            cursor: pointer;
            display: inline-block;
            margin-bottom: 10px;
            &.active1 {
              background: rgba(80, 136, 255, 0.15);
              color: #5088ff;
            }
            .circle {
              width: 24px;
              height: 16px;
              line-height: 16px;
              background: #ff5000;
              border-radius: 8px;
              display: block;
              position: absolute;
              top: -8px;
              right: -8px;
              font-weight: bold;
              color: #ffffff;
              font-size: 12px;
              text-align: center;
            }
          }
        }
      }
      &.stImTime {
        .stType {
          span {
            margin-right: 16px;
            padding: 4px 16px;
            box-sizing: border-box;
            cursor: pointer;
            &.active2 {
              color: #5088ff;
              background: rgba(80, 136, 255, 0.2);
              border-radius: 4px;
            }
          }
        }
      }
      .ss {
        width: 80px;
        min-width: 80px;
      }
    }
  }
}
.page.zntjMd {
  position: relative;
}
</style>
